import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJSON from "./en.json";
import esJSON from "./es.json";
import frJSON from "./fr.json";
import requestEn from "./request/en.json";
import requestEs from "./request/es.json";
import requestFr from "./request/fr.json";
import cashDepositEn from "./cash-deposit/en.json";
import cashDepositEs from "./cash-deposit/es.json";
import cashDepositFr from "./cash-deposit/fr.json";
import fundRequestEn from "./fund-request/en.json";
import fundRequestEs from "./fund-request/es.json";
import fundRequestFr from "./fund-request/fr.json";
import payoutClaimEn from "./payout-claim/en.json";
import payoutClaimEs from "./payout-claim/es.json";
import payoutClaimFr from "./payout-claim/fr.json";
import deferredOriginationEn from "./deferred-origination/en.json";
import deferredOriginationEs from "./deferred-origination/es.json";
import deferredOriginationFr from "./deferred-origination/fr.json";
import m2mEn from "./m2m/en.json";
import m2mEs from "./m2m/es.json";
import m2mFr from "./m2m/fr.json";
import starterEn from "./starter/en.json";
import starterEs from "./starter/es.json";
import starterFr from "./starter/fr.json";
import sendEn from "./send/en.json";
import sendEs from "./send/es.json";
import sendFr from "./send/fr.json";
import smartEn from "./smart/en.json";
import smartEs from "./smart/es.json";
import smartFr from "./smart/fr.json";
import consumerAuthEn from "./consumer-auth/en.json";
import consumerAuthEs from "./consumer-auth/es.json";
import consumerAuthFr from "./consumer-auth/fr.json";
import lolaEn from "./lola/en.json";
import lolaEs from "./lola/es.json";
import lolaFr from "./lola/fr.json";
import firstSendEn from "./first-send/en.json";
import firstSendEs from "./first-send/es.json";
import firstSendFr from "./first-send/fr.json";
import phoneCaptureEn from "./phone-capture/en.json";
import phoneCaptureEs from "./phone-capture/es.json";
import phoneCaptureFr from "./phone-capture/fr.json";
import smsTermsEn from "./sms-terms/en.json";
import smsTermsEs from "./sms-terms/es.json";
import smsTermsFr from "./sms-terms/fr.json";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        ...enJSON,
        request: requestEn,
        "cash-deposit": cashDepositEn,
        "fund-request": fundRequestEn,
        "payout-claim": payoutClaimEn,
        "deferred-origination": deferredOriginationEn,
        m2m: m2mEn,
        starter: starterEn,
        send: sendEn,
        smart: smartEn,
        "consumer-auth": consumerAuthEn,
        lola: lolaEn,
        firstSend: firstSendEn,
        phoneCapture: phoneCaptureEn,
        smsTerms: smsTermsEn,
      },
      es: {
        ...esJSON,
        request: requestEs,
        "cash-deposit": cashDepositEs,
        "fund-request": fundRequestEs,
        "payout-claim": payoutClaimEs,
        "deferred-origination": deferredOriginationEs,
        m2m: m2mEs,
        starter: starterEs,
        send: sendEs,
        smart: smartEs,
        "consumer-auth": consumerAuthEs,
        lola: lolaEs,
        firstSend: firstSendEs,
        phoneCapture: phoneCaptureEs,
        smsTerms: smsTermsEs,
      },
      fr: {
        ...frJSON,
        request: requestFr,
        "cash-deposit": cashDepositFr,
        "fund-request": fundRequestFr,
        "payout-claim": payoutClaimFr,
        "deferred-origination": deferredOriginationFr,
        m2m: m2mFr,
        starter: starterFr,
        send: sendFr,
        smart: smartFr,
        "consumer-auth": consumerAuthFr,
        lola: lolaFr,
        firstSend: firstSendFr,
        phoneCapture: phoneCaptureFr,
        smsTerms: smsTermsFr,
      },
    },
    fallbackLng: "en",
    detection: {
      order: ["navigator", "localStorage", "sessionStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
